// --- COMPONENT: CATEGORIES SECTION ---
// File: /components/CategoriesSection.jsx
import { ASSETS } from "../assets/assets";
import CategoryCard from "./CategoryCard";

const CategoriesSection = () => {
  const categories = [
    { km: "8", img: ASSETS.category8k, elevation: "474 +M", cutOff: "5 Hours" },
    { km: "18", img: ASSETS.category16k, elevation: "1370 +M", cutOff: "7 Hours" },
    { km: "32", img: ASSETS.category32k, elevation: "2132 +M", cutOff: "9 Hours" },
    { km: "50", img: ASSETS.category50k, elevation: "3187 +M", cutOff: "13 Hours" },
  ];

  return (
    <section className="py-10 bg-gray-300 border-t border-gray-200">
      <div className="container px-4 mx-auto">

        {/* Header Box Title */}
        <div className="relative z-10 flex justify-center mb-16 -mt-28">
          <div className="px-12 py-4 bg-gray-300 border-t-4 border-black shadow-xl">
            <h2 className="text-3xl font-black tracking-widest text-black uppercase">
              Categories
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {categories.map((cat, idx) => (
            <CategoryCard key={idx} {...cat} />
          ))}
        </div>

      </div>
    </section>
  );
};

export default CategoriesSection;
